let prdPrevBtn = document.querySelectorAll(".slide-prev");
let prdNextBtn = document.querySelectorAll(".slide-next");

let deskPrdPrevBtn = document.querySelectorAll(".slide-prev-desk");
let deskPrdNextBtn = document.querySelectorAll(".slide-next-desk");

let sliderDot = document.querySelectorAll(".slider-dots span");
let sliderWrap = document.querySelectorAll(".product-media-content");
let PrdVariantOptions = document.querySelectorAll(".variants-option input");

const mediaScroll = (el, dir, scrollVal) => {
  let parentWrapper = el
    .closest(".product-container")
    .querySelector(".product-media-content");
  let currentSlide = parentWrapper.querySelector(
    ".product-media-container.active"
  );
  let slideWidth = currentSlide.getBoundingClientRect().width;
  dir
    ? (parentWrapper.scrollLeft -= slideWidth)
    : (parentWrapper.scrollLeft += slideWidth);
  scrollVal
    ? (parentWrapper.scrollLeft = slideWidth * (Number(scrollVal) - 1))
    : "";
};

const mediaScrollDesk = (el, dir, scrollVal) => {
  let parentWrapper = document.querySelector(
    ".product-media-content-parent .product-media-content-inner"
  );
  let currentSlide = parentWrapper.querySelector(
    ".product-media-container.active"
  );
  let slideWidth = currentSlide.getBoundingClientRect().width;
  dir
    ? (parentWrapper.scrollLeft -= slideWidth)
    : (parentWrapper.scrollLeft += slideWidth);
  scrollVal
    ? (parentWrapper.scrollLeft = slideWidth * (Number(scrollVal) - 1))
    : "";
};

const updateInWindowClasses = (slider) => {
  if (!slider) return;
  const sliderRect = slider.getBoundingClientRect();
  slider.querySelectorAll(".product-media-container").forEach((slide) => {
    const rect = slide.getBoundingClientRect();
    const horizontallyVisible =
      rect.left < sliderRect.right && rect.right > sliderRect.left;
    const verticallyVisible =
      rect.top < sliderRect.bottom && rect.bottom > sliderRect.top;
    if (horizontallyVisible && verticallyVisible) {
      slide.classList.add("in-window");
    } else {
      slide.classList.remove("in-window");
    }
  });
};

sliderWrap.forEach((slider) => {
  slider.addEventListener("scroll", function () {
    let activeIndex = Math.floor(
      this.scrollLeft / Math.floor(this.getBoundingClientRect().width)
    );
    this.querySelectorAll(".product-media-container").forEach(function (el, ind) {
      if (ind == activeIndex) {
        el.classList.add("active");
      } else {
        el.classList.remove("active");
      }
    });
    updateInWindowClasses(this);
    sliderDot.forEach(function (el, ind) {
      if (ind == activeIndex) {
        el.classList.add("active");
        el.closest(".slider-dots").scrollLeft =
          el.getBoundingClientRect().width * ind;
      } else {
        el.classList.remove("active");
      }
    });
  });
  updateInWindowClasses(slider);
});

window.addEventListener("resize", () => {
  sliderWrap.forEach((slider) => updateInWindowClasses(slider));
});

prdPrevBtn.forEach(function (el, ind) {
  el.addEventListener("click", function (e) {
    e.preventDefault();
    mediaScroll(el, true);
  });
});
prdNextBtn.forEach(function (el, ind) {
  el.addEventListener("click", function (e) {
    e.preventDefault();
    mediaScroll(el, false);
  });
});

deskPrdPrevBtn.forEach(function (el, ind) {
  el.addEventListener("click", function (e) {
    e.preventDefault();
    mediaScrollDesk(el, true);
  });
});
deskPrdNextBtn.forEach(function (el, ind) {
  el.addEventListener("click", function (e) {
    e.preventDefault();
    mediaScrollDesk(el, false);
  });
});
sliderDot.forEach(function (el, ind) {
  el.addEventListener("click", function (e) {
    e.preventDefault();
    mediaScroll(el, null, el.dataset.index);
  });
});
/////////////////////updating variant images
function updateVariantImage(variant) {
  let media = document.querySelectorAll(".product-media-container");
  media.forEach((el, ind) => {
    let variantOpt = el.querySelector("img").getAttribute("alt");
    console.log(variantOpt);
    if (variantOpt == variant.toLowerCase()) {
      mediaScroll(el, null, ind);
    }
  });
}
PrdVariantOptions.forEach((el, ind) => {
  el.addEventListener("change", function () {
    if (el.checked) {
      let value = el.value.toLowerCase();
      updateVariantImage(value);
    }
  });
});
